import { lazy } from "react";
import ScheduleAppointment from "../views/appointmentConfirmed";
import DiscoveryQueue from "../views/discoveryQueue";

const Insurance = lazy(() => import("../views/insurance"));
const Welcome = lazy(() => import("../components/Welcome/Welcome"));
const Register = lazy(() => import("../components/Register/Register"));
const PaymentSetup = lazy(() => import("../components/PaymentSetup/PaymentSetup"));
const RegistrationInsuranceVerification = lazy(() =>
  import(
    "../components/RegistrationSetup/Insurance/RegistrationInsuranceVerification/RegistrationInsuranceVerification"
  )
);
const RegistrationInsuranceChecking = lazy(() =>
  import(
    "../components/RegistrationSetup/Insurance/RegistrationInsuranceChecking/RegistrationInsuranceChecking"
  )
);
const RegistrationInsuranceCoverageFound = lazy(() =>
  import(
    "../components/RegistrationSetup/Insurance/RegistrationInsuranceCoverageFound/RegistrationInsuranceCoverageFound"
  )
);
const RegistrationInsuranceNotFound = lazy(() =>
  import(
    "../components/RegistrationSetup/Insurance/RegistrationInsuranceNotFound/RegistrationInsuranceNotFound"
  )
);
const RegistrationInsuranceInformation = lazy(() =>
  import(
    "../components/RegistrationSetup/Insurance/RegistrationInsuranceInformation/RegistrationInsuranceInformation"
  )
);
const RegistrationCardOnFile = lazy(() =>
  import("../components/RegistrationSetup/CardOnFile/RegistrationCardOnFile")
);
const RegistrationTherapistList = lazy(() =>
  import(
    "../components/RegistrationSetup/Therapist/RegistrationTherapistList/RegistrationTherapistList"
  )
);
const RegistrationTherapistProfile = lazy(() =>
  import(
    "../components/RegistrationSetup/Therapist/RegistrationTherapistProfile/RegistrationTherapistProfile"
  )
);
const RegistrationSchedule = lazy(() =>
  import("../components/RegistrationSetup/Schedule/RegistrationSchedule")
);
const RegistrationNoPreferenceSchedule = lazy(() =>
  import(
    "../components/RegistrationSetup/Schedule/RegistrationNoPreferenceSchedule/RegistrationNoPreferenceSchedule"
  )
);
const RegistrationNoPreferenceTherapistProfile = lazy(() =>
  import(
    "../components/RegistrationSetup/Therapist/RegistrationNoPreferenceTherapistProfile/RegistrationNoPreferenceTherapistProfile"
  )
);
const RegistrationCalendlyBooking = lazy(() =>
  import("../components/RegistrationSetup/Schedule/RegistrationCalendlyBooking")
);
const RegistrationBookingConfirmation = lazy(() =>
  import(
    "../components/RegistrationSetup/Confirmation/RegistrationBookingConfirmation"
  )
);
const RegistrationAppDownload = lazy(() =>
  import(
    "../components/RegistrationSetup/AppDownload/RegistrationAppDownload"
  )
);
const RegistrationAllSet = lazy(() =>
  import("../components/RegistrationSetup/AppDownload/RegistrationAllSet")
);
const RegistrationNoRdAvailable = lazy(() =>
  import(
    "../components/RegistrationSetup/NoRdAvailable/RegistrationNoRdAvailable"
  )
);
const Slots = lazy(() => import("../views/slots"));
const CounselorList = lazy(() => import("../views/counselorList"));
const AppointmentConfirmation = lazy(() =>
  import("../views/appointmentConfirmation")
);
const Preference = lazy(() => import("../views/preference"));
const MobileAppointment = lazy(() => import("../views/mobileAppointment"));
const StaticPage = lazy(() => import("../views/staticPage"));
const StaticPageFromQuery = lazy(() =>
  import("../views/staticPage").then((module) => ({
    default: module.StaticPageFromQuery,
  }))
);
const ForgotPassword = lazy(() => import("../views/forgotPassword"));
const AddCard = lazy(() => import("../views/AddCard"));

export const publicRoutes = [
  {
    path: "/register/account/insurance/checking",
    component: <RegistrationInsuranceChecking />,
  },
  {
    path: "/register/account/insurance/coverage",
    component: <RegistrationInsuranceCoverageFound />,
  },
  {
    path: "/register/account/insurance/no-match",
    component: <RegistrationInsuranceNotFound />,
  },
  {
    path: "/register/account/insurance/details",
    component: <RegistrationInsuranceInformation />,
  },
  {
    path: "/register/account/insurance",
    component: <RegistrationInsuranceVerification />,
  },
  {
    path: "/register/account/app-download",
    component: <RegistrationAppDownload />,
  },
  {
    path: "/register/account/all-set",
    component: <RegistrationAllSet />,
  },
  {
    path: "/register/account/confirmation",
    component: <RegistrationBookingConfirmation />,
  },
  {
    path: "/register/account/no-preference/schedule",
    component: <RegistrationNoPreferenceSchedule />,
  },
  {
    path: "/register/account/no-preference/therapists/:therapistId",
    component: <RegistrationNoPreferenceTherapistProfile />,
  },
  {
    path: "/register/account/schedule",
    component: <RegistrationSchedule />,
  },
  {
    path: "/register/account/calendly-booking",
    component: <RegistrationCalendlyBooking />,
  },
  {
    path: "/register/account/therapists/:therapistId",
    component: <RegistrationTherapistProfile />,
  },
  {
    path: "/register/account/therapists",
    component: <RegistrationTherapistList />,
  },
  {
    path: "/register/account/card",
    component: <RegistrationCardOnFile />,
  },
  {
    path: "/register/account/payment",
    component: <PaymentSetup />,
  },
  {
    path: "/register/account/no-rd-available",
    component: <RegistrationNoRdAvailable />,
  },
  {
    path: "/register/account",
    component: <Register />,
  },
  {
    path: "/register",
    component: <Welcome />,
  },
  {
    path: "/insurance",
    component: <Insurance />,
  },
  {
    path: "/book-mobile-appointment",
    component: <MobileAppointment />,
  },
  {
    path: "/static-page",
    component: <StaticPageFromQuery />,
  },
  {
    path: "/terms",
    component: <StaticPage type={"terms"} />,
  },
  {
    path: "/privacy",
    component: <StaticPage type={"privacy"} />,
  },
  {
    path: "/hipaa-consent",
    component: <StaticPage type={"hippa"} />,
  },
  {
    path: "/generate-thoughts-passcode",
    component: <ForgotPassword />,
  },
  {
    path: "/payment",
    component: <StaticPage type={"payment"} />,
  },
];

export const protectedRoutes = [
  {
    path: "/preference",
    component: <Preference />,
  },
  {
    path: "/counselor-slots",
    component: <Slots />,
  },
  {
    path: "/counselor-list",
    component: <CounselorList />,
  },
  {
    path: "/appointment-confirmation",
    component: <AppointmentConfirmation />,
  },
  {
    path: "/schedule-appointment",
    component: <ScheduleAppointment />,
  },
  {
    path: "/discovery-queue",
    component: <DiscoveryQueue />,
  },
  {
    path: "/add-card",
    component: <AddCard />,
  },
];
